<template>
  <div class="index">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <!-- 定宽布局 -->
    <div class="my-container">
      <!-- 活动推荐  st -->
      <div class="banenr">
        <!-- <h2>活动推荐</h2> -->
        <div class="b-con">
          <a href="javascript:;"><img src="/imgs/ct1.jpg" alt="" /></a>
          <a href="javascript:;"><img src="/imgs/ct2.jpg" alt="" /></a>
          <a href="javascript:;"><img src="/imgs/ct3.jpg" alt="" /></a>
        </div>
      </div>
      <!-- 活动推荐  end -->

      <!-- 热门推荐 st -->
      <div class="mc-rec">
        <h2>热门动漫推荐</h2>
        <!-- 容器列表 -->
        <div class="rec-con">
          <!-- 循环项 *4 -->
          <div
            class="rec-item"
            v-for="(item, index) in this.dataList"
            :key="index"
            @click="goDays(item.methods, item.id)"
          >
            <!-- 图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
              <!-- 图标 -->
              <i class="iconfont icon-bofang"></i>
            </div>
            <!-- 歌曲名称 -->
            <p>{{ item.title }}</p>
            <!-- <span>付费观看：3元</span> -->
            <span>开始阅读</span>
          </div>
        </div>
      </div>
      <!-- 热门推荐 end -->

      <!-- banner2 st -->
      <div class="banner2">
        <!-- <img src="/imgs/i-banner2.jpg" alt="" /> -->
        <img src="/imgs/ac-banner.jpg" alt="" />
      </div>
      <!-- banner2 end -->
    </div>

    <!-- 弹框 -->
    <modal
      title="请选择支付方式"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img src="/imgs/pay.png" />
        <p>扫码收费：2元</p>
      </template>
    </modal>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
// import navigation from "./../components/navigation";
// import as from "./../components/a";
import Modal from "./../components/Modal.vue";
// import Ma from "./../components/Ma.vue";

export default {
  name: "index",
  data() {
    return {
      tabShow: true,
      state: JSON.parse(window.localStorage.getItem("state")),
      href: "/",
      // 音乐列表
      songList: [],
      // 总页数
      pages: 6,
      // 当前页
      pageNo: 1,
      // 点击页数
      curPage: 1,
      // 根据页数获取数据
      dataList: [],

      drawer: false,
      direction: "ltr",
      my_lyc: [],
      my_title: "",
      imgUrl: "",
      showModal: false,
    };
  },
  components: {
    NavHeader,
    Modal,
  },
  mounted() {
    document.title = "杭州含情网络技术有限公司";
    this.init();
  },
  methods: {
    init() {
      // 渲染数据
      this.axios.get("/mock/a1.json").then((res) => {
        console.log(res);
        var data = res.data;
        // 根数据
        this.dataList = data;
      });
    },
     // 跳转 逻辑 封装
    goDays(methodsWords, type) {
      this[methodsWords](type);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + 1,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay(id) {
      this.$router.push({
        path: "/sound2/:" + 1,
        query: { type: id },
      });
    },
    // 分页器事件 //根据当前页获取数据
    msgListView(curPage) {
      this.curPage = curPage;
      // // console.log(this.curPage);
      // this.init();
      if (this.curPage == "1") {
        this.init();
      } else if (this.curPage == "2") {
        this.init2();
      } else if (this.curPage == "3") {
        this.init3();
      } else if (this.curPage == "4") {
        this.init4();
      } else if (this.curPage == "5") {
        this.init5();
      } else if (this.curPage == "6") {
        this.init6();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import url("https://www.jq22.com/jquery/bootstrap-3.3.4.css");
.index {
  .my-container {
    padding-left: 19%;
    box-sizing: border-box;

    // 活动推荐
    .banenr {
      width: 100%;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        font-weight: bold;
        color: $colorB;
        cursor: pointer;
      }
      .b-con {
        width: 100%;
        height: 250px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 365px;
          height: 200px;
          display: block;
          border-radius: 12px;
          // background-color: red;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            transform: translateY(-5px);
          }
        }
      }
    }

    // 热门推荐
    .mc-rec {
      width: 100%;
      h2 {
        font-size: 16px;
        font-weight: bold;
        color: $colorB;
        cursor: pointer;
        margin: 30px 0;
      }

      // 容器列表
      .rec-con {
        width: 100%;
        // height: 350px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        // 循环项
        .rec-item {
          width: 270px;
          // height: 280px;
          cursor: pointer;
          margin: 15px 0;
          &:hover {
            .item-img {
              i {
                opacity: 1;
              }
            }
          }
          // 图片
          .item-img {
            width: 100%;
            height: 350px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            i {
              font-size: 40px;
              position: absolute;
              right: 15%;
              bottom: -15%;
              color: $colorA;
              font-weight: bold;
              opacity: 0;
              transition: all 0.3s;
            }
          }

          // 歌曲名称
          p {
            font-size: 14px;
            color: $colorC;
            margin: 15px 0;
          }

          // 歌手名称
          span {
            font-size: 14px;
            color: $colorD;
          }
        }
      }
    }

    // 音乐top榜单
    .mc-top {
      width: 100%;
      h2 {
        font-size: 16px;
        font-weight: bold;
        color: $colorB;
        cursor: pointer;
      }
      // 容器
      .top-con {
        width: 100%;
        // height: 600px;
        background: #f1f4fd;
        margin: 30px 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        // 循环项
        .top-item {
          width: 44%;
          height: 75px;
          margin: 15px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s;
          cursor: pointer;
          padding-right: 30px;
          box-sizing: border-box;
          &:hover {
            background: #fff;
            .item-img {
              i {
                opacity: 1;
              }
            }
          }
          // 歌曲图片
          .item-img {
            width: 75px;
            height: 75px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            i {
              font-size: 35px;
              position: absolute;
              left: 26%;
              top: 17%;
              // color: #888;
              color: #000;
              font-weight: bold;
              opacity: 0;
              transition: all 0.3s;
            }
          }

          // 歌曲名
          .item-title {
            font-size: 14px;
            color: $colorB;
            width: 120px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          // 歌手
          .item-name {
            font-size: 14px;
            color: $colorB;
          }

          // 下载图标
          .item-pay {
            i {
              font-size: 24px;
              color: $colorB;
            }
          }
        }
      }
    }

    // banenr2
    .banner2 {
      width: 100%;
      height: 400px;
      margin: 30px 0;
      background: pink;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
